module.exports = __webpack_public_path__ + "static/media/logo.24e1641e.png";